/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {bindActionCreators} from "redux"
import {Button, Card, Grid, Input, InputLabel, Modal, Notification, Radio, Select, Table} from '@scuf/common'
import * as AppConfigActions from './AppConfigActions'
import {DataTable} from '@scuf/datatable'
import Loader from '../../common/Loader'
import {showNotification} from "../../common/ToastNotification";
import {formatDateTime, formatMessage} from "../../common/LocaleHelper";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import StatusIcon from "../../common/StatusIcon";
import SubmitPasswordModal from "../../common/SubmitPasswordModal";
import {
    isAdminConnectionEnabled, checkAdminConnection, setAdminConnection,
    DatabaseType,
    fetchLdiNamesAndIds,
    LdiImportAvailabilityResult,
    LdiImportRevertResult,
    LdiImportUpdateResult, refreshSpringConfiguration
} from "../../api/AppConfigs";
import LdiSelector from "../../common/LdiSelector";
import {getUIconfigs, UIconfigNames} from "../../api/UIconfig";

class AppConfig extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            appConfigData: null,
            changedAppConfigRows: [],
            selectedRevertOption: null,
            closeModalImportOpen: false,
            closeModalRevertOpen: false,
            closeModalValidationResults: false,
            closeModalCorruptedFaultsOpen: false,
            adminConnectionUserName: '',
            adminConnectionPassword: '',
            adminConnectionModalOpen: false,
            adminConnectionModalLoading: false,
            adminConnectionModalProceed: false,
            adminConnectionModalCallback: null,
            validationResults: null,
            databaseType: DatabaseType.UNKNOWN,
            radioValue: "",
            ldiNamesAndIds: null,
            selectedLdiForHDR: -1,
        }

        this.saveConfig = this.saveConfig.bind(this)
        this.editData = this.editData.bind(this)
        this.submitPassword = this.submitPassword.bind(this)
        this.fetchLdiImportAvailability = this.fetchLdiImportAvailability.bind(this)
        this.runLdiImport = this.runLdiImport.bind(this)
        this.fetchRevertOptions = this.fetchRevertOptions.bind(this)
        this.fetchMemoryRequirementsImport = this.fetchMemoryRequirementsImport.bind(this);
        this.fetchMemoryRequirementsRevert = this.fetchMemoryRequirementsRevert.bind(this);
        this.fetchLdiNamesAndIds = this.fetchLdiNamesAndIds.bind(this)
        this.fetchRestOfData = this.fetchRestOfData.bind(this)

        this.openModalCorruptedFaults = this.openModalCorruptedFaults.bind(this)
        this.checkAdminConnection = this.checkAdminConnection.bind(this)
    }

    componentDidMount() {
        this.fetchLdiNamesAndIds()
        getUIconfigs([UIconfigNames.LDI_IMPORT_KEEP_FAULTS]).then((response) => {
            this.setState({radioValue: response.length === 0 ? "" : response[0].status === 'ACTIVE' ? 'KEEP' : 'DELETE'})
        })
    }

    fetchRestOfData() {
        this.props.AppConfigActions.fetchAppConfigs(this.state.selectedLdiForHDR).catch(err => {
            showNotification({
                translationPropertyKey: err,
                severity: "critical",
            });
        })
        this.fetchTestKmsConnection();
        this.fetchLdiImportAvailability();
        this.fetchRevertOptions();
    }

    fetchLdiNamesAndIds() {
        const me = this
        fetchLdiNamesAndIds().then(function (response) {
            if (response.length === 1) {
                me.setState({ldiNamesAndIds: response, selectedLdiForHDR: response[0].value}, me.fetchRestOfData)
            } else {
                me.setState({ldiNamesAndIds: response})
            }
        });
    }

    fetchMemoryRequirementsImport() {
        this.props.AppConfigActions.getMemoryRequirements(this.state.selectedLdiForHDR, true).then(() => this.setState({closeModalImportOpen: true}));
    }

    fetchMemoryRequirementsRevert() {
        this.props.AppConfigActions.getMemoryRequirements(this.state.selectedLdiForHDR, false).then(() => this.setState({closeModalRevertOpen: true}));
    }

    checkAdminConnection(adminConnectionCallbackFn) {
        const {intl} = this.props
        isAdminConnectionEnabled()
            .then(enabled => {
                if (enabled) {
                    this.setState({
                        adminConnectionModalProceed: false,
                        adminConnectionModalOpen: true,
                        adminConnectionModalLoading: true,
                    })
                    checkAdminConnection()
                        .then((isValid) => {
                            this.setState({
                                adminConnectionModalLoading: false,
                                adminConnectionModalProceed: isValid,
                                adminConnectionModalCallback: adminConnectionCallbackFn,
                            })
                            isValid ? showNotification({
                                    translationPropertyKey: 'admin.connection.modal.valid',
                                    severity: "success",
                                }) :
                                showNotification({
                                    translationPropertyKey: 'admin.connection.modal.no.valid.established',
                                    severity: "critical",
                                })
                        })
                        .catch(() => this.setState({adminConnectionModalLoading: false}))
                } else {
                    adminConnectionCallbackFn() // run the original onClick event when Admin connection is disabled
                }
            })
    }

    openModalCorruptedFaults() {
        this.setState({closeModalCorruptedFaultsOpen: true});
    }

    fetchTestKmsConnection() {
        this.props.AppConfigActions.testKmsConnection(this.state.selectedLdiForHDR)
    }

    fetchLdiImportAvailability() {
        this.props.AppConfigActions.ldiImportAvailability(this.state.selectedLdiForHDR)
    }

    runLdiImport() {
        const radioValue = this.state.radioValue
        this.setState({closeModalImportOpen: false, radioValue: ""})
        this.props.AppConfigActions.requestRunLdiImport(this.state.selectedLdiForHDR, radioValue)
    }

    openModalWindowImport() {
        const {intl, freeSpace, expectedNeededSpace} = this.props
        return (
            <Modal closeIcon={false} onClose={() => this.setState({closeModalImportOpen: false})} open={this.state.closeModalImportOpen} closeOnDimmerClick={false} id="memory-modal">
                <Modal.Header>
                    <FormattedMessage id="admin.app.config.ldi.import.memory.requirements"/>
                </Modal.Header>
                <Modal.Content>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell id="computer-only"/>
                            <Table.HeaderCell id="computer-only">
                                <FormattedMessage id="admin.app.config.ldi.import.size.mb"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell id="mobile-only">
                                <FormattedMessage id="admin.app.config.ldi.import.mobile.requirements"/>
                            </Table.HeaderCell>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <FormattedMessage id="admin.app.config.ldi.import.freeSpace"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {freeSpace != null ?
                                        Number(freeSpace.toFixed(2))
                                        :
                                        0
                                    }
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>
                                    <FormattedMessage id="admin.app.config.ldi.import.expectedNeededSpace"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {expectedNeededSpace != null ?
                                        Number(expectedNeededSpace.toFixed(2))
                                        :
                                        0
                                    }
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row className="result-row">
                                <Table.Cell>
                                    <FormattedMessage id="admin.app.config.ldi.import.result"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {
                                        freeSpace > expectedNeededSpace ?
                                            <div className="sufficient">
                                                <FormattedMessage id="admin.app.config.ldi.import.sufficient"/>
                                            </div>
                                            :
                                            <div className="insufficient">
                                                <FormattedMessage id="admin.app.config.ldi.import.insufficient"/>
                                            </div>
                                    }
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.cancel"})}
                                onClick={() => this.setState({closeModalImportOpen: false})} size="medium"
                                type="secondary"/>
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "admin.app.config.ldi.import.proceed"})}
                                onClick={() => this.runLdiImport()} size="medium" type="primary"
                                disabled={freeSpace <= expectedNeededSpace}/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        )
    }

    openModalWindowRevert(options) {
        const {intl, freeSpace, expectedNeededSpace} = this.props
        return (
            <Modal closeIcon={false} onClose={() => this.setState({closeModalRevertOpen: false})} open={this.state.closeModalRevertOpen} closeOnDimmerClick={false} id="memory-modal">
                <Modal.Header>
                    <FormattedMessage id="admin.app.config.ldi.import.memory.requirements"/>
                </Modal.Header>
                <Modal.Content>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell id="computer-only"/>
                            <Table.HeaderCell id="computer-only">
                                <FormattedMessage id="admin.app.config.ldi.import.size.mb"/>
                            </Table.HeaderCell>
                            <Table.HeaderCell id="mobile-only">
                                <FormattedMessage id="admin.app.config.ldi.import.mobile.requirements"/>
                            </Table.HeaderCell>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <FormattedMessage id="admin.app.config.ldi.import.freeSpace"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {freeSpace != null ?
                                        Number(freeSpace.toFixed(2))
                                        :
                                        0
                                    }
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>
                                    <FormattedMessage id="admin.app.config.ldi.import.expectedNeededSpace"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {expectedNeededSpace != null ?
                                        Number(expectedNeededSpace.toFixed(2))
                                        :
                                        0
                                    }
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row className="result-row">
                                <Table.Cell>
                                    <FormattedMessage id="admin.app.config.ldi.import.result"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {
                                        freeSpace > expectedNeededSpace ?
                                            <div className="sufficient">
                                                <FormattedMessage id="admin.app.config.ldi.import.sufficient"/>
                                            </div>
                                            :
                                            <div className="insufficient">
                                                <FormattedMessage id="admin.app.config.ldi.import.insufficient"/>
                                            </div>
                                    }
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.cancel"})}
                                onClick={() => this.setState({closeModalRevertOpen: false})} size="medium"
                                type="secondary"/>
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "admin.app.config.ldi.import.proceed"})}
                                onClick={() => this.onClickRevertButton(options)} size="medium" type="primary"
                                disabled={freeSpace <= expectedNeededSpace}/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        )
    }

    adminConnectionModal() {
        const {intl} = this.props
        return (
            <Modal closeIcon={false} onClose={() => this.setState({adminConnectionModalOpen: false})}
                   open={this.state.adminConnectionModalOpen} closeOnDimmerClick={false} id="memory-modal">
                <Modal.Header>
                    <FormattedMessage id="admin.connection.modal.header"/>
                </Modal.Header>
                <Modal.Content>
                    <Grid.Row>
                        <Grid.Column width={11} sWidth={6}>
                            <div>
                                <InputLabel label={intl.formatMessage({id: "login.username"})}/>
                                <Input fluid
                                       value={this.state.adminConnectionUserName}
                                       onChange={(data) => this.setState({adminConnectionUserName: data})}
                                       placeholder={intl.formatMessage({id: "admin.connection.modal.username"})}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={11} sWidth={6}>
                            <div>
                                <InputLabel label={intl.formatMessage({id: "login.password"})}/>
                                <Input fluid
                                       value={this.state.adminConnectionPassword}
                                       onChange={(data) => this.setState({adminConnectionPassword: data})}
                                       placeholder={intl.formatMessage({id: "admin.connection.modal.password"})}
                                       type="password"
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.cancel"})}
                                onClick={() => this.setState({
                                    adminConnectionUserName: '',
                                    adminConnectionPassword: '',
                                    adminConnectionModalOpen: false,
                                })} size="medium"
                                type="secondary"/>
                        <Button
                            className="mobile-max-width-button"
                            size="medium"
                            type={this.state.adminConnectionModalProceed ? "secondary" : "primary"}
                            disabled={!(this.state.adminConnectionUserName && this.state.adminConnectionPassword)}
                            content={this.state.adminConnectionModalProceed ? intl.formatMessage({id: "admin.connection.modal.modify"}) : intl.formatMessage({id: "admin.connection.modal.set"})}
                            onClick={() => {
                                this.setState({adminConnectionModalLoading: true})
                                setAdminConnection(this.state.adminConnectionUserName, this.state.adminConnectionPassword)
                                    .then((isConnectionValid) => {
                                        this.setState({adminConnectionModalLoading: false})
                                        if (isConnectionValid) {
                                            refreshSpringConfiguration() // refresh beans only if connection is valid
                                                .then(() => {
                                                    this.setState({
                                                        adminConnectionModalProceed: isConnectionValid,
                                                    })
                                                    showNotification({
                                                        translationPropertyKey: 'admin.connection.modal.success',
                                                        severity: "success",
                                                    })
                                                })
                                        } else {
                                            // Connection is preserved if it has been already successfully established
                                            this.state.adminConnectionModalProceed ?
                                                showNotification({
                                                    translationPropertyKey: 'admin.connection.modal.kept',
                                                    severity: "important",
                                                }) :
                                                showNotification({
                                                    translationPropertyKey: 'admin.connection.modal.can.not.establish',
                                                    severity: "critical",
                                                })
                                        }
                                    })
                                    .catch(() => {
                                        this.setState({adminConnectionModalLoading: false})
                                    })
                            }}
                        />
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "admin.app.config.ldi.import.proceed"})}
                                onClick={() => {
                                    this.setState({
                                        adminConnectionUserName: '',
                                        adminConnectionPassword: '',
                                        adminConnectionModalOpen: false,
                                    }, () => this.state.adminConnectionModalCallback());
                                }} size="medium" type={"primary"}
                                disabled={!this.state.adminConnectionModalProceed}/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.state.adminConnectionModalLoading}/>
            </Modal>
        )
    }

    openModalValidationResults() {
        const {intl} = this.props
        let newResults = null;
        if (this.state.validationResults != null && this.state.validationResults.length > 0) {
            newResults = this.formatValidationResults(this.state.validationResults)
        }
        return (
            <Modal closeIcon={false} onClose={() => this.setState({closeModalValidationResults: false})}
                   open={this.state.closeModalValidationResults} closeOnDimmerClick={false} id="memory-modal">
                <Modal.Header>
                    <FormattedMessage id="admin.app.config.ldi.import.validationResults"/>
                </Modal.Header>
                <Modal.Content>
                    {newResults != null && newResults.missing != null && newResults.missing.length > 0 ?
                        <div>
                            <h4>
                                {this.state.databaseType === DatabaseType.LDI ?
                                    <FormattedMessage id="admin.app.config.ldi.import.missing.data.ldi"/>
                                    :
                                    <FormattedMessage id="admin.app.config.ldi.import.missing.data.app"/>
                                }
                            </h4>
                            <Table>
                                <Table.Header>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="admin.app.config.ldi.import.tableName"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="admin.app.config.ldi.import.columnName"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="admin.app.config.ldi.import.columnType"/>
                                    </Table.HeaderCell>
                                </Table.Header>
                                <Table.Body>
                                    {this.getRows(newResults.missing)}
                                </Table.Body>
                            </Table>
                        </div>
                        :
                        null
                    }
                    {newResults != null && newResults.extra != null && newResults.extra.length > 0 ?
                        <div>
                            <h4 className="extra-data-h4">
                                {this.state.databaseType === DatabaseType.LDI ?
                                    <FormattedMessage id="admin.app.config.ldi.import.extra.data.ldi"/>
                                    :
                                    <FormattedMessage id="admin.app.config.ldi.import.extra.data.app"/>
                                }
                            </h4>
                            <Table>
                                <Table.Header>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="admin.app.config.ldi.import.tableName"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="admin.app.config.ldi.import.columnName"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="admin.app.config.ldi.import.columnType"/>
                                    </Table.HeaderCell>
                                </Table.Header>
                                <Table.Body>
                                    {this.getRows(newResults.extra)}
                                </Table.Body>
                            </Table>
                        </div>
                        :
                        null
                    }
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button" content={intl.formatMessage({id: "fault.detail.action.cancel"})} onClick={() => this.setState({closeModalValidationResults: false})} size="medium" type="secondary" />
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        )
    }

    openModalWindowPossibleCorruptedFaults() {
        const {intl} = this.props
        return (
            <Modal closeIcon={false} onClose={() => this.setState({closeModalCorruptedFaultsOpen : false})} open={this.state.closeModalCorruptedFaultsOpen} closeOnDimmerClick={false} id="memory-modal">
                <Modal.Header>
                    <FormattedMessage id="admin.app.config.ldi.import.corrupted.faults.header"/>
                </Modal.Header>
                <Modal.Content>
                    <div>
                        <Radio
                            label={intl.formatMessage({id: "admin.app.config.ldi.import.corrupted.faults.delete"})}
                            name="radio1"
                            checked={this.state.radioValue === "DELETE"}
                            onChange={() => this.setState({radioValue: "DELETE"})}
                        />
                    </div>
                    <div>
                        <Radio
                            label={intl.formatMessage({id: "admin.app.config.ldi.import.corrupted.faults.keep"})}
                            name="radio2"
                            checked={this.state.radioValue === "KEEP"}
                            onChange={() => this.setState({radioValue: "KEEP"})}
                        />
                    </div>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button" content={intl.formatMessage({id: "fault.detail.action.cancel"})} onClick={() => this.setState({closeModalCorruptedFaultsOpen: false})} size="medium" type="secondary" />
                        <Button
                            className="mobile-max-width-button"
                            content={intl.formatMessage({id: "admin.app.config.ldi.import.proceed"})}
                            onClick={() => {
                                this.setState({closeModalCorruptedFaultsOpen: false})
                                this.fetchMemoryRequirementsImport();
                            }}
                            size="medium"
                            type="primary"
                            disabled={this.state.radioValue === ""}
                        />
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        )
    }

    formatValidationResults(results) {
        let missingResults = results.filter(r =>
            r.currentDatabaseTableName !== null &&
            r.currentDatabaseColumnName !== null &&
            r.currentDatabaseColumnType !== null)
        let extraResults = results.filter(r =>
            r.currentDatabaseTableName == null ||
            r.currentDatabaseColumnName == null ||
            r.currentDatabaseColumnType == null)
        missingResults = missingResults.map(r => {
            return {
                tableName: r.currentDatabaseTableName,
                columnName: r.currentDatabaseColumnName,
                columnType: r.currentDatabaseColumnType,
            }
        })
        extraResults = extraResults.map(r => {
            return {
                tableName: r.newDatabaseTableName,
                columnName: r.newDatabaseColumnName,
                columnType: r.newDatabaseColumnType,
            }
        })
        return {missing: missingResults, extra: extraResults};
    }

    getRows(data) {
        return data.map(d => {
            return (
                <Table.Row>
                    <Table.Cell>{d.tableName}</Table.Cell>
                    <Table.Cell>{d.columnName}</Table.Cell>
                    <Table.Cell>{d.columnType}</Table.Cell>
                </Table.Row>
            )
        })
    }

    fetchRevertOptions() {
        this.props.AppConfigActions.getRevertOptions(this.state.selectedLdiForHDR)
    }

    saveConfig() {
        this.props.AppConfigActions.updateAppConfigs(this.state.selectedLdiForHDR, this.state.appConfigData).then(() => {
            showNotification({
                translationPropertyKey: 'admin.app.config.update.success',
                severity: "success",
            })
            this.setState({appConfigData: null, changedAppConfigRows: []});
            this.fetchTestKmsConnection()
            this.fetchLdiImportAvailability()
        }).catch(err => {
            showNotification({
                translationPropertyKey: err.errorKey,
                severity: "critical",
            })
        })
    }

    editData(newVal, cellData){
        const appConfigData = this.props.appConfigData;
        appConfigData[cellData.rowIndex][cellData.field] = newVal;
        this.setState({appConfigData: appConfigData, changedAppConfigRows: this.state.changedAppConfigRows.concat(cellData.rowIndex)});
    }

    isReadOnly() {
        return !userHasActivity(this.props.userProfile, ACTIVITY_TYPES.CONFIG_WRITE)
    }

    getKmsConnectionStatus() {
        const {intl, kmsConnection} = this.props

        let kmsConnectionStatusMessage
        let kmsConnectionStatusColor
        if (!kmsConnection.loading && kmsConnection.success == null) {

        } else if (kmsConnection.loading) {
            kmsConnectionStatusMessage = <Loader loading={true} text="" overlayOpacity={0} className="small"/>
        } else if (kmsConnection.success === true) {
            kmsConnectionStatusColor = "green"
            kmsConnectionStatusMessage = <FormattedMessage id="dashboard.connection.KMS.connected"/>
        } else {
            kmsConnectionStatusColor = "red"
            if (kmsConnection.connectionError != null && kmsConnection.connectionError.errorKey != null) {
                kmsConnectionStatusMessage = <FormattedMessage id={kmsConnection.connectionError.errorKey}/>
            }
        }
        return <Grid>
            <Grid.Row>
                <Grid.Column width={1} sWidth={4}>
                    <div>
                        <StatusIcon color={kmsConnectionStatusColor}/> <FormattedMessage id="dashboard.connection.KMS"/>
                    </div>
                </Grid.Column>
                <Grid.Column width={11} sWidth={6} className="small-loader-wrap">
                    {kmsConnectionStatusMessage}
                    <SubmitPasswordModal open={kmsConnection.submitPasswordModalOpen}
                                         onClose={this.props.AppConfigActions.closePasswordModal}
                                         onSubmit={this.submitPassword} connectorMessage={kmsConnection.connectionError}
                                         loading={kmsConnection.loading}/>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={12}>
                    <div className="button-panel">
                        <div className="cancel-save-button-div">
                            {!kmsConnection.success ?
                                <Button type="primary"
                                        content={intl.formatHTMLMessage({id: 'admin.app.config.kms.password'})}
                                        onClick={this.props.AppConfigActions.openPasswordModal}
                                        className="mobile-max-width-button"
                                />
                                :
                                ''
                            }
                        </div>
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    }

    getLdiImportAvailabilityStatus() {
        const {kmsConnection, ldiImport, intl, importLoading, ldiImportAvailabilityResult} = this.props;
        let ldiImportStatusMessage
        let color
        let currentVersionMessage
        let newVersionMessage
        let importResult = null;
        if (!kmsConnection.loading && kmsConnection.success == null) {

        } else if (kmsConnection.loading) {
            ldiImportStatusMessage = <Loader loading={true} text="" overlayOpacity={0} className="small"/>
        } else if (kmsConnection.success === true) {
            if (importLoading) {
                ldiImportStatusMessage = <Loader loading={true} text="" overlayOpacity={0} className="small"/>
            } else {
                let message;
                if (ldiImportAvailabilityResult == null) {
                    message = intl.formatMessage({id: 'admin.app.config.ldi.import.ERROR'})
                    ldiImportStatusMessage = <span>{message}</span>;
                } else {
                    if (ldiImportAvailabilityResult.ldiImportAvailabilityResult === LdiImportAvailabilityResult.LDI_IMPORT_KMS_PROCESSING_ERROR) {
                        message = ldiImportAvailabilityResult.errorMessage
                    } else {
                        message = intl.formatMessage({id: 'admin.app.config.ldi.import.' + ldiImportAvailabilityResult.ldiImportAvailabilityResult});
                    }
                    ldiImportStatusMessage = <span>{message}</span>;
                    const currentVersion = ldiImportAvailabilityResult != null ? ldiImportAvailabilityResult.currentLdiVersion : null;
                    const newVersion = ldiImportAvailabilityResult != null ? ldiImportAvailabilityResult.newLdiVersion : null;
                    currentVersionMessage = currentVersion == null ?
                        <FormattedMessage id='admin.app.config.ldi.import.currentVersion.notAvailable'/>
                        :
                        <FormattedMessage id='admin.app.config.ldi.import.currentVersion'
                                          values={{date: formatDateTime(currentVersion)}}/>
                    if (ldiImportAvailabilityResult.ldiImportAvailabilityResult === LdiImportAvailabilityResult.LDI_IMPORT_UPDATE_AVAILABLE) {
                        color = "green"
                        newVersionMessage = newVersion == null ?
                            <FormattedMessage id='admin.app.config.ldi.import.newVersion.notAvailable'/>
                            :
                            <FormattedMessage id='admin.app.config.ldi.import.newVersion'
                                              values={{date: formatDateTime(newVersion)}}/>
                    } else if (ldiImportAvailabilityResult.ldiImportAvailabilityResult === LdiImportAvailabilityResult.LDI_IMPORT_NO_UPDATE_NEEDED) {
                        color = "blue"
                        newVersionMessage = null
                    } else {
                        color = "red"
                        newVersionMessage = null
                    }

                    if (ldiImport.result != null) {
                        const idString = "admin.app.config.ldi.import.import." + ldiImport.result;
                        let severity;
                        let validationResulstButton = null;
                        if (ldiImport.result === LdiImportUpdateResult.LDI_IMPORT_UPDATE_SUCCESS) {
                            severity = "success";
                        } else {
                            severity = "critical"
                            if (ldiImport.result === LdiImportUpdateResult.LDI_IMPORT_UPDATE_INCORRECT_DATABASE_SCHEMA) {
                                validationResulstButton =
                                    <Button
                                        className="see-results"
                                        content={intl.formatMessage({id: 'admin.app.config.ldi.import.button.results'})}
                                        type="link"
                                        onClick={() => this.setState({
                                            closeModalValidationResults: true,
                                            databaseType: DatabaseType.LDI,
                                            validationResults: ldiImport.ldiValidationResults,
                                        })}
                                    />
                            }
                        }
                        importResult =
                            <Grid.Row>
                                <Grid.Column>
                                    <Notification
                                        hasIcon={true}
                                        severity={severity}
                                    >
                                        <span>
                                            {<FormattedMessage id={idString}/>}
                                            <br/>
                                            {ldiImport.wasRevertSuccessful ?
                                                <FormattedMessage id={"admin.app.config.ldi.import.import.revertResult.success"}/>
                                                :
                                                ldiImport.wasRevertSuccessful == null ?
                                                    null
                                                    :
                                                    <FormattedMessage
                                                        id={"admin.app.config.ldi.import.import.revertResult.failed"}/>
                                            }
                                            <div>
                                                {validationResulstButton}
                                            </div>
                                        </span>
                                    </Notification>
                                </Grid.Column>
                            </Grid.Row>
                    }
                }
            }

        } else {
            color = "red"
            if (kmsConnection.connectionError != null && kmsConnection.connectionError.errorKey != null) {
                ldiImportStatusMessage = <FormattedMessage id={kmsConnection.connectionError.errorKey}/>
            }
        }

        return (
            <Grid className="ldiImport-table">
                {importResult}
                <Grid.Row>
                    <Grid.Column width={1} sWidth={4} >
                        <div>
                            <StatusIcon color={color}/> <FormattedMessage id="dashboard.connection.KMS"/>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={11} sWidth={6} className="small-loader-wrap">
                        {ldiImportStatusMessage}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className="versions">
                    <Grid.Column width={6} sWidth={12} className="current">{currentVersionMessage}</Grid.Column>
                    <Grid.Column width={6} sWidth={12} className="new">
                        <span>
                            {newVersionMessage}
                            {newVersionMessage != null ?
                                <Button
                                    type="link"
                                    onClick={() => {
                                        this.checkAdminConnection(this.openModalCorruptedFaults)
                                    }}
                                    disabled={this.isReadOnly()}
                                >
                                    <FormattedMessage id="dashboard.versions.updatenow"/>
                                </Button>
                                :
                                null
                            }
                        </span>
                    </Grid.Column>
                </Grid.Row>
                {this.openModalWindowImport()}
                {this.openModalValidationResults()}
                {this.openModalWindowPossibleCorruptedFaults()}
            </Grid>
        )
    }

    getRevertOptionsToRender(revertOptions) {
        return revertOptions.map(
            (v, i) => {
                return {value: i, text: formatDateTime(v), original: v}
            }
        );
    }

    onClickRevertButton(options) {
        const opt = this.state.selectedRevertOption
        if (options.length > 0 && this.state.selectedRevertOption != null) {
            const option = options.filter(o => {
                return o.value === opt
            })
            if (option.length > 0) {
                this.setState({selectedRevertOption: null, closeModalRevertOpen: false})
                this.props.AppConfigActions.requestRevertToVersion(this.state.selectedLdiForHDR, option[0].original)
            }
        }
    }

    renderRevertOptions() {
        const {revertOptions, intl, importLoading, revertResult} = this.props
        if (importLoading) {
            const options = this.getRevertOptionsToRender(revertOptions)
            return (
                <div>
                    <Loader loading={true} text="" overlayOpacity={0} className="small"/>
                    <div>
                        <Select className="revertSelector"
                                label={intl.formatMessage({id: 'admin.app.config.revert.dates'})}
                                placeholder={intl.formatMessage({id: "admin.app.config.ldi.import.revertOptions"})}
                                options={options}
                                fluid
                                disabled={true}
                                onChange={(data) => {this.setState({selectedRevertOption: data})}}
                        />
                        <Button
                            className="buttonRevert mobile-max-width-button"
                            disabled={true}
                            content={intl.formatMessage({id: "admin.app.config.ldi.import.revert"})}
                        />
                        {this.openModalWindowRevert(options)}
                    </div>
                </div>
            )
        }
        let notification;
        if (revertResult != null && revertResult.result !== LdiImportRevertResult.LDI_IMPORT_REVERT_NO_INFORMATION) {
            const idString = "admin.app.config.revert." + revertResult.result;
            let severity;
            let revertString;
            let validationResultButton = null;
            if (revertResult.result === LdiImportRevertResult.LDI_IMPORT_REVERT_SUCCESS) {
                severity = "success";
            } else {
                severity = "critical"
                revertString = "admin.app.config.revert.false." + revertResult.revert
                if (revertResult.result === LdiImportRevertResult.LDI_IMPORT_REVERT_APP_SCHEMA_ERROR ||
                    revertResult.result === LdiImportRevertResult.LDI_IMPORT_REVERT_LDI_SCHEMA_ERROR) {
                    validationResultButton =
                        <Button
                            className="see-results"
                            content={intl.formatMessage({id: 'admin.app.config.ldi.import.button.results'})}
                            type="link"
                            onClick={() => this.setState({
                                closeModalValidationResults: true,
                                databaseType: revertResult.databaseType,
                                validationResults: revertResult.databaseValidationResults,
                            })}
                        />
                }
            }
            notification =
                <Notification
                    hasIcon={true}
                    severity={severity}
                >
                    <span>
                        {<FormattedMessage id={idString}/>}
                        <br/>
                        {revertResult.revert == null ? null : <FormattedMessage id={revertString}/>}
                        <div>
                            {validationResultButton}
                        </div>
                    </span>
                </Notification>
        }
        const options = this.getRevertOptionsToRender(revertOptions)
        const readOnly = this.isReadOnly()
        const disabled = readOnly || (options.length <= 0);
        return (
            <div>
                {notification}
                <Select className="revertSelector"
                        label={intl.formatMessage({id: 'admin.app.config.revert.dates'})}
                        placeholder={intl.formatMessage({id: "admin.app.config.ldi.import.revertOptions"})}
                        options={options}
                        fluid
                        disabled={disabled}
                        onChange={(data) => {
                            this.setState({selectedRevertOption: data})
                        }}
                />
                <Button className="buttonRevert mobile-max-width-button"
                        disabled={this.state.selectedRevertOption == null}
                        content={intl.formatMessage({id: "admin.app.config.ldi.import.revert"})}
                        onClick={() => {
                            this.checkAdminConnection(this.fetchMemoryRequirementsRevert)
                        }}/>
                {this.openModalWindowRevert(options)}
                {this.openModalValidationResults()}
            </div>
        )
    }

    submitPassword(componentState) {
        const {AppConfigActions, intl} = this.props
        this.setState({submitPasswordLoading: true})
        AppConfigActions.submitPassword(this.state.selectedLdiForHDR, componentState.password).then(() => {
            showNotification({
                translationPropertyKey: 'admin.password.modal.success',
                severity: "success",
            })
            this.fetchTestKmsConnection()
            this.fetchLdiImportAvailability()
        }).catch((err) => {
            if(err && err.generalError === true) {
                showNotification({
                    translationPropertyKey: err.errorKey,
                    severity: "critical",
                });
            }
        });
    }

    valueRenderer(cellData) {
        const {intl} = this.props;

        if (this.state.changedAppConfigRows.includes(cellData.rowIndex)) {
            return <span>{cellData.value} <span className="unsaved-config-row">({intl.formatMessage({id: 'admin.app.config.unsaved'})})</span></span>;
        } else {
            return cellData.value;
        }
    }

    render() {
        const {intl, appConfigData, loading} = this.props
        const data = this.translateDescriptions(appConfigData)

        let ldiSelector = null
        if (this.state.ldiNamesAndIds != null) {
            if (this.state.ldiNamesAndIds.length > 1) {
                ldiSelector =
                    <LdiSelector
                        ldiNamesAndIds={this.state.ldiNamesAndIds}
                        selectedLdiForHDR={this.state.selectedLdiForHDR}
                        onLdiChange={(newLdi) => {
                            this.setState({
                                selectedLdiForHDR: newLdi,
                            }, () => {
                                this.fetchRestOfData()
                            });
                        }}
                        getErrorMessage={() => {
                        }}
                    />
            }
        }

        return (
            <div id="app-config">
                {this.state.ldiNamesAndIds != null && this.state.ldiNamesAndIds.length > 1 ?
                    <Card>
                        <Card.Header title={intl.formatMessage({id: "multipleLdis.selection.header"})}/>
                        <Card.Content>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={4} sWidth={12}>
                                        <div className="ldiSelector">
                                            {ldiSelector}
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Card.Content>
                    </Card>
                    :
                    null
                }
                {
                    this.state.selectedLdiForHDR === -1 ?
                        null
                        :
                        <React.Fragment>
                            <Card>
                                <Loader loading={loading}/>
                                <Card.Header title={intl.formatMessage({id : 'admin.app.config.title'})} />
                                <Card.Content>
                                    <DataTable data={data} showHeader={false}
                                               onEdit={(newData, cellData) => this.editData(newData, cellData)}
                                    >
                                        <DataTable.Column field="description" header="Description" />
                                        <DataTable.Column field="value" header="Value" editable={!this.isReadOnly()}
                                                          renderer={(cellData) => this.valueRenderer(cellData)}/>
                                    </DataTable>
                                    <div className="button-panel">
                                        <div className="cancel-save-button-div">
                                            <Button type="primary"
                                                    content={intl.formatMessage({id: 'admin.app.config.save'})}
                                                    onClick={this.saveConfig} className="mobile-max-width-button"
                                                    disabled={this.isReadOnly() || this.state.appConfigData == null}/>
                                        </div>
                                    </div>
                                </Card.Content>
                            </Card>

                            <Card>
                                <Loader loading={loading}/>
                                <Card.Header title={intl.formatMessage({id: 'admin.app.config.kms.title'})}/>
                                <Card.Content>
                                    {this.getKmsConnectionStatus()}
                                </Card.Content>
                            </Card>
                            <Card>
                                <Loader loading={loading}/>
                                <Card.Header title={intl.formatMessage({id: 'admin.app.config.ldi.import'})}>
                                    <div className="right">
                                        <Button type="primary" size="small" onClick={() => {
                                            this.fetchLdiImportAvailability();
                                            this.fetchRevertOptions();
                                        }}>
                                            <FormattedMessage id="dashboard.versions.update.refresh"/>
                                        </Button>
                                    </div>
                                </Card.Header>
                                <Card.Content>
                                    {this.getLdiImportAvailabilityStatus()}
                                </Card.Content>
                            </Card>
                            <Card>
                                <Loader loading={loading}/>
                                <Card.Header title={intl.formatMessage({id: 'admin.app.config.revert'})}>
                                    <div className="right">
                                        <Button type="primary" size="small" onClick={() => {
                                            this.fetchRevertOptions();
                                        }}>
                                            <FormattedMessage id="admin.app.config.reload"/>
                                        </Button>
                                    </div>
                                </Card.Header>
                                <Card.Content>
                                    {this.renderRevertOptions()}
                                </Card.Content>
                            </Card>
                            {this.adminConnectionModal()}
                        </React.Fragment>
                }
            </div>
        )

    }

    translateDescriptions(appConfigData) {
        for (const i in appConfigData) {
            if (appConfigData.hasOwnProperty(i)) {
                const ac = appConfigData[i];
                ac.description = formatMessage({id: 'admin.app.config.property.' + ac.name});
            }
        }
        // Check all mandatory elements, if they are missing, need to be added with '' value
        let element = appConfigData.find(a => a.name === 'KMS_LL_URL')
        if (element == null) {
            appConfigData.push({name: 'KMS_LL_URL', value: '', description: formatMessage({id: 'admin.app.config.property.KMS_LL_URL'})})
        }
        element = appConfigData.find(a => a.name === 'KMS_LL_USERNAME')
        if (element == null) {
            appConfigData.push({name: 'KMS_LL_USERNAME', value: '', description: formatMessage({id: 'admin.app.config.property.KMS_LL_USERNAME'})})
        }
        element = appConfigData.find(a => a.name === 'KMS_LL_PROJECT')
        if (element == null) {
            appConfigData.push({name: 'KMS_LL_PROJECT', value: '', description: formatMessage({id: 'admin.app.config.property.KMS_LL_PROJECT'})})
        }
        element = appConfigData.find(a => a.name === 'KMS_LL_FLEET')
        if (element == null) {
            appConfigData.push({name: 'KMS_LL_FLEET', value: '', description: formatMessage({id: 'admin.app.config.property.KMS_LL_FLEET'})})
        }
        element = appConfigData.find(a => a.name === 'HDR_RF_SF_DAY_RANGE')
        if (element == null) {
            appConfigData.push({name: 'HDR_RF_SF_DAY_RANGE', value: '', description: formatMessage({id: 'admin.app.config.property.HDR_RF_SF_DAY_RANGE'})})
        }
        element = appConfigData.find(a => a.name === 'HDR_FAULT_AUTOCLOSE_DAY_RANGE')
        if (element == null) {
            appConfigData.push({
                name: 'HDR_FAULT_AUTOCLOSE_DAY_RANGE',
                value: '',
                description: formatMessage({id: 'admin.app.config.property.HDR_FAULT_AUTOCLOSE_DAY_RANGE'}),
            })
        }
        return(appConfigData)
    }
}

const sortRevertOptions = (a, b) => {
    let comparison = 0
    if (a.text > b.text) {
        comparison = -1;
    } else if (a.text < b.text) {
        comparison = 1;
    }
    return comparison;
}

const mapStateToProps = (state) => {
    return {
        appConfigData: state.appConfigsReducer.appConfigData,
        userProfile: state.security.userProfile,
        loading: state.appConfigsReducer.loading,
        kmsConnection: state.appConfigsReducer.kmsConnection,
        ldiImport: state.appConfigsReducer.ldiImport,
        revertOptions: state.appConfigsReducer.revertOptions,
        ldiImportAvailabilityResult: state.appConfigsReducer.ldiImportAvailabilityResult,
        importLoading: state.appConfigsReducer.importLoading,
        revertResult: state.appConfigsReducer.revertResult,
        freeSpace: state.appConfigsReducer.freeSpace,
        expectedNeededSpace: state.appConfigsReducer.expectedNeededSpace,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AppConfigActions: bindActionCreators(AppConfigActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AppConfig)))
